import React, { useEffect, memo } from "react"
import { Navigate, useRoutes } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux"
import routes from "./routes"
import { Skeleton } from '@mui/material'
import PermissionDenied from "./views/PermissionDenied"


// remove some path on these server modes (current: uat, staging, production)
const removeThesePath = [
  {
    path: "kpi",
    children: [
      //"mygoal-detail/:serial/chart",
      //"evaluation/previous",
      "performance-evaluation/previous",
    ]
  },
  {
    path: "admin",
    children: [
      "manage-corporate-goal/:serial/chart",
      "email-notification-center",
      "email-notification-center/:id",
    ]
  }
]

if (process.env.REACT_APP_MODE === "uat" || process.env.REACT_APP_MODE === "staging" || process.env.REACT_APP_MODE === "production") {
  let currentRoutes = [...routes]
  let removePath = [...removeThesePath]
  currentRoutes.forEach((route, idxRoute) => {
    removePath.forEach(remove => {
      if (remove?.path === route?.path) {
        route?.children?.forEach((children, idxChildren) => {
          if (remove?.children?.includes(children?.path)) {
            routes[idxRoute].children?.splice(idxChildren, 1)
          }
        })
      }
    })
  })
}

// check permission & added permission denied component
const filterWildcard = (list, str) => {
  let result = list.filter((item) => {
    return typeof item == 'string' && item.includes(str)
  })
  return result?.length > 0 ? true : false
}

const finalizedRoutes = (routes, userPermission, admin) => {
  const checkChildren = (child, permissions) => {
    let result = []
    result = child?.children?.map(child => {
      if (child?.ignore) {
        return child
      } else {
        if (permissions.includes(child.permission)) {
          if (child?.children && child?.children?.length > 0) {
            child.children = checkChildren(child.children, permissions)
          }
          return child
        } else {
          return {
            ...child,
            element: <PermissionDenied />
          }
        }
      }
    })
    return result
  }

  const checkProtectedRoute = (route) => {
    return route.children.map(child => {
      // bypass if "ignore" = true
      if (child?.ignore) {
        return child
      } else {
        // find wildcard & validate permisssion
        let permSplit = child.permission?.split("*")
        let havePermission = false
        if (permSplit?.length > 1) {
          permSplit = permSplit.filter(split => split !== "")
          havePermission = filterWildcard(userPermission, permSplit[0])
        } else {
          havePermission = userPermission.includes(child.permission)
        }

        // do check permission
        if (havePermission) {
          if (child?.children && child?.children?.length > 0) {
            child.children = checkChildren(child, userPermission)
          }
          return child
        } else {
          return {
            ...child,
            element: <PermissionDenied />
          }
        }
      }
    })
  }

  let resultRoutes = [...routes]
  userPermission = [...new Set(userPermission)]
  // protected
  resultRoutes = resultRoutes.map(route => {
    if (admin) {
      if (route.protected) {
        route.children = checkProtectedRoute(route)
      }
    } else {
      if (route.isAdmin) {
        route = {
          ...route,
          element: <PermissionDenied />
        }
      } else {
        if (route.protected) {
          route.children = checkProtectedRoute(route)
        }
      }
    }
    return route
  })
  return resultRoutes
}


// first load, set Skeleton to component
const preGuardRoutes = [...routes].map(route => {
  if (route?.default) {
    return route
  } else {
    return {
      ...route,
      element: <Skeleton />
    }
  }
})

const Routers = memo(() => {
  const proxy = JSON.parse(localStorage.getItem("proxy"));
  const stateUser = useSelector((state) => state.auth)
  const [routers, setRouters] = React.useState(preGuardRoutes)

  const performAuthenRouters = () => {
    let isAdmin = false
    let user = JSON.parse(JSON.stringify(stateUser.user))
    //let permissions = user?.permission ?? []
    let permissions = proxy?.proxy_token !== undefined ? proxy?.permission : user?.permission
    //console.log('permissions', permissions)

    let allowRoutes = []
    if (permissions.length > 0) {
      for (let i = 0; i < permissions.length; i++) {
        allowRoutes.push(permissions[i]?.code ?? "")
      }
      // check admin
      for (let i = 0; i < permissions.length; i++) {
        if (permissions[i]?.is_admin) {
          isAdmin = true
          break
        }
      }
    }
    setRouters(finalizedRoutes(routes, allowRoutes, isAdmin))
  }

  useEffect(() => {
    if (stateUser?.user) {
      performAuthenRouters()
    }
  }, [stateUser.user])

  return useRoutes(routers)
})

export default Routers
